define.alias("ember-composable-helpers/helpers/has-previous", "media/helpers/has-previous");